import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const DonutChart3 = ({
  data,
  labels,
  colors,
  year,
  legendItems,
  size = 320,
  cutoutPercentage = 65,
}) => {
  const patternsRef = useRef([]); 
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const containerRef = useRef(null);
  const boxRefs = useRef([]);
  const legendCanvasRefs = useRef([]);

  useEffect(() => {
    if (!canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    const ctx = canvasRef.current.getContext('2d');

  const patterns = colors.map((color, i) => {

  const pCanvas = document.createElement('canvas');
  pCanvas.width = 12;   // 👈 thoda bara
  pCanvas.height = 12;
  const pCtx = pCanvas.getContext('2d');

  pCtx.strokeStyle = color;
  pCtx.fillStyle = color;
  pCtx.lineWidth = 1.5; // 👈 thoda light

  switch (i) {
    case 0: // diagonal /
      for (let x = -12; x < 12; x += 6) { // 👈 spacing increase
        pCtx.beginPath();
        pCtx.moveTo(x, 12);
        pCtx.lineTo(x + 12, 0);
        pCtx.stroke();
      }
      break;

    case 1: // diagonal \
      for (let x = -12; x < 12; x += 6) {
        pCtx.beginPath();
        pCtx.moveTo(x, 0);
        pCtx.lineTo(x + 12, 12);
        pCtx.stroke();
      }
      break;

 case 2: // diagonal grid pattern (lines only)
  const size = 12;
  const gap = 4;

  // 🔸 Diagonal lines ( / )
  for (let i = -size; i < size * 2; i += gap) {
    // pCtx.strokeStyle = "rgb(240, 145, 105)"; // solid color, no alpha
    pCtx.lineWidth = 0.5; // optional: thin
    pCtx.beginPath();
    pCtx.moveTo(i, 0);
    pCtx.lineTo(i + size, size);
    pCtx.stroke();
  }

  // 🔸 Diagonal lines ( \ )
  for (let i = -size; i < size * 2; i += gap) {
    pCtx.strokeStyle = "rgb(194, 65, 12)"; // solid color
    pCtx.beginPath();
    pCtx.moveTo(i, size);
    pCtx.lineTo(i + size, 0);
    pCtx.stroke();
  }

  break;
      

    case 3: // dots (light)
      for (let x = 3; x < 12; x += 6) {
        for (let y = 3; y < 12; y += 6) {
          pCtx.beginPath();
          pCtx.arc(x, y, 1, 0, Math.PI * 2); // 👈 small dots
          pCtx.fill();
        }
      }
      break;

     case 4: // modern hatch + dot mix
{
  const size = 12;

  // 🔹 Light diagonal strokes
  pCtx.strokeStyle = color;
  pCtx.lineWidth = 0.8;

  for (let i = -size; i < size * 2; i += 6) {
    pCtx.beginPath();
    pCtx.moveTo(i, 0);
    pCtx.lineTo(i + size, size);
    pCtx.stroke();
  }

  // 🔹 Micro accent dots (very subtle)
  pCtx.fillStyle = color;

  const dotPositions = [
    [3, 3],
    [9, 9],
    [3, 9],
    [9, 3],
  ];

  dotPositions.forEach(([x, y]) => {
    pCtx.beginPath();
    pCtx.arc(x, y, 0.8, 0, Math.PI * 2);
    pCtx.fill();
  });

  break;
}

    default:
      break;
  }

  return ctx.createPattern(pCanvas, 'repeat');
});
patternsRef.current = patterns;
    chartRef.current = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            data,
            backgroundColor: patterns,
            borderWidth: 3,
            borderColor: '#ffffff',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: `${cutoutPercentage}%`,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false },
        },
        // animation: { onComplete } block replace karo is se:

animation: {
  onComplete: () => {
    const chart = chartRef.current;
    if (!chart) return;
    const meta = chart.getDatasetMeta(0);
    const centerX = chart.chartArea.left + chart.chartArea.width / 2;
    const centerY = chart.chartArea.top + chart.chartArea.height / 2;
    const radius = meta.data[0]?.outerRadius || size / 2;
    const container = containerRef.current;
    if (!container) return;

    const GAP = 4;
    const CONTAINER_W = container.offsetWidth;
    const CONTAINER_H = container.offsetHeight;

    boxRefs.current.forEach(box => {
      if (box) {
        box.style.visibility = 'hidden';
        box.style.opacity = '1';
        box.style.left = '0px';
        box.style.top = '0px';
      }
    });

    const items = meta.data.map((arc, i) => {
      const midAngle = (arc.startAngle + arc.endAngle) / 2;
      const box = boxRefs.current[i];
      const boxW = box ? box.offsetWidth : 90;
      const boxH = box ? box.offsetHeight : 20;

      // ✅ dist kam kiya — labels donut ke paas rahenge
      const dist = radius * 1.45;
      
      const anchorX = centerX + dist * Math.cos(midAngle);
      const anchorY = centerY + dist * Math.sin(midAngle);

      let x = anchorX - boxW / 2;
      let y = anchorY - boxH / 2;

      if (Math.cos(midAngle) > 0.2) {
        x = anchorX;
      } else if (Math.cos(midAngle) < -0.2) {
        x = anchorX - boxW;
      }

      // ✅ X clamp — container ke andar rakho
      x = Math.max(0, Math.min(x, CONTAINER_W - boxW));
      // ✅ Y clamp — upar/neeche na jaaye
      y = Math.max(0, Math.min(y, CONTAINER_H - boxH));

      return { i, x, y, w: boxW, h: boxH, midAngle, anchorX, anchorY };
    });

    const overlaps = (a, b) => {
      return !(
        a.x + a.w + GAP < b.x ||
        b.x + b.w + GAP < a.x ||
        a.y + a.h + GAP < b.y ||
        b.y + b.h + GAP < a.y
      );
    };

    const MAX_ITER = 60;
    for (let iter = 0; iter < MAX_ITER; iter++) {
      let anyOverlap = false;
      for (let a = 0; a < items.length; a++) {
        for (let b = a + 1; b < items.length; b++) {
          if (!overlaps(items[a], items[b])) continue;
          anyOverlap = true;

          const overlapY = (items[a].h + items[b].h) / 2 + GAP - Math.abs(items[a].y - items[b].y);
          const pushY = overlapY / 2 + 1;
          if (items[a].y < items[b].y) {
            items[a].y -= pushY;
            items[b].y += pushY;
          } else {
            items[a].y += pushY;
            items[b].y -= pushY;
          }

          const overlapX = (items[a].w + items[b].w) / 2 + GAP - Math.abs(items[a].x - items[b].x);
          if (overlapX > 0) {
            const pushX = overlapX / 2 + 1;
            if (items[a].x < items[b].x) {
              items[a].x -= pushX * 0.3;
              items[b].x += pushX * 0.3;
            } else {
              items[a].x += pushX * 0.3;
              items[b].x -= pushX * 0.3;
            }
          }

          // ✅ Har iteration ke baad bhi clamp lagao
          items[a].x = Math.max(0, Math.min(items[a].x, CONTAINER_W - items[a].w));
          items[a].y = Math.max(0, Math.min(items[a].y, CONTAINER_H - items[a].h));
          items[b].x = Math.max(0, Math.min(items[b].x, CONTAINER_W - items[b].w));
          items[b].y = Math.max(0, Math.min(items[b].y, CONTAINER_H - items[b].h));
        }
      }
      if (!anyOverlap) break;
    }

    items.forEach(({ i, x, y }) => {
      const box = boxRefs.current[i];
      if (box) {
        box.style.left = `${x}px`;
        box.style.top = `${y}px`;
        box.style.visibility = 'visible';
        box.style.opacity = '1';
      }
    });
  },
},
      },
    });

    patternsRef.current = patterns;
    setTimeout(() => {
      patternsRef.current.forEach((pattern, idx) => {
        const canvas = legendCanvasRefs.current[idx];
        if (!canvas || !pattern) return;

        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, 12, 12);
        ctx.fillStyle = pattern;
        ctx.fillRect(0, 0, 12, 12);
      });
    }, 50);

    return () => chartRef.current?.destroy();
  }, [data, labels, colors, size, cutoutPercentage]);

  // Easy contrast color function
const getContrastColor = (hexColor) => {
  if (!hexColor) return '#000';

  // Remove # if present
  let color = hexColor.replace('#', '');
  
  // Convert to RGB
  const r = parseInt(color.substr(0, 2), 16);
  const g = parseInt(color.substr(2, 2), 16);
  const b = parseInt(color.substr(4, 2), 16);

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? '#111111' : '#ffffff';   // Dark bg pe white, light bg pe black
};

  return (
    <div
      ref={containerRef}
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <canvas ref={canvasRef} />

      {/* CENTER YEAR + VERTICAL LEGEND */}
      <div className="absolute text-center pointer-events-none">
        <div className="text-sm font-bold text-foreground">{year}</div>
        <div className="flex flex-col items-center gap-1 mt-1 text-[9px] font-semibold">
          {legendItems?.map((item, idx) => (
            <div key={idx} className="flex items-center gap-1 whitespace-nowrap">
  <canvas
  width={12}
  height={12}
  className=""

  ref={(el) => { legendCanvasRefs.current[idx] = el; }}
/>

  <span className="text-foreground whitespace-nowrap">{item.label}</span>
</div>
          ))}
        </div>
      </div>

      {/* LABEL + PERCENTAGE BOXES — overlap-resolved */}
      {/* {data.map((val, i) => (
        <div
          key={i}
          ref={(el) => (boxRefs.current[i] = el)}
          className="absolute bg-foreground text-background text-[10px] font-bold px-2 py-0.5  pointer-events-none whitespace-nowrap"
          style={{ position: 'absolute', opacity: 0, transition: 'opacity 0.2s' }}
          ref={(el) => {
            boxRefs.current[i] = el;
            // Start hidden, reveal after chart animation places them
            if (el) setTimeout(() => { el.style.opacity = 1; }, 350);
          }}
        >
          {labels[i]}: {val.toFixed(2)}%
        </div>
      ))} */}

            {/* LABEL + PERCENTAGE BOXES */}
      {data.map((val, i) => (
        <div
          key={i}
          ref={(el) => {
            boxRefs.current[i] = el;
            // Fade in after chart animation
            if (el) {
              setTimeout(() => {
                el.style.opacity = '1';
              }, 400);
            }
          }}
          className="bg-foreground text-background absolute text-[10px] font-bold px-3 py-1  pointer-events-none whitespace-nowrap border border-white/30 shadow-sm"
          style={{
            position: 'absolute',
            opacity: 0,
            transition: 'opacity 0.3s ease',
            // backgroundColor: colors[i],
            // color: getContrastColor(colors[i]),
          }}
        >
          {labels[i]}: {(val || 0).toFixed(2)}%
        </div>
      ))}
    </div>
  );
};

export default DonutChart3;